export default "__VITE_ASSET__lE0u5lzY__"